import { render, staticRenderFns } from "./GoogleTranslate.vue?vue&type=template&id=5f685480"
import script from "./GoogleTranslate.vue?vue&type=script&lang=js"
export * from "./GoogleTranslate.vue?vue&type=script&lang=js"
import style0 from "./GoogleTranslate.vue?vue&type=style&index=0&id=5f685480&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports